import React, { useCallback, useEffect } from "react";
import Stack from "./Stack";
import { Badge, Text } from "@fluentui/react-components";
import { NOT_AVAILABLE, PARTIALLY_AVAILABLE } from "../variables";
import { useTranslation } from "react-i18next";

function Status(props) {
  const {
    room = {},
    startTime,
    endTime,
    setStatus = () => { }
  } = props;

  const { t } = useTranslation();

  const timeToMinutes = (time) => {
    if (!time) return 0;
    const [hours, minutes] = time.split(':').map(Number)
    return hours * 60 + minutes;
  }

  const dateToHHMM = (date) => {
    if (!date) return null;
    return date.toLocaleTimeString('en-GB', { hour: '2-digit', minute: '2-digit' });
  };

  const determineStatus = useCallback(() => {
    let status = { message: t('Not Available'), className: NOT_AVAILABLE };

    if (!startTime || !endTime || !room.availability) {
      return status;
    }

    const eventStartStr = dateToHHMM(startTime);
    const eventEndStr = dateToHHMM(endTime);

    const eventStartMinutes = timeToMinutes(eventStartStr);
    const eventEndMinutes = timeToMinutes(eventEndStr);

    // Check for full availability
    const isFullyAvailable = room.availability.some(([start, end]) => {
      return timeToMinutes(start) <= eventStartMinutes && timeToMinutes(end) >= eventEndMinutes;
    });

    if (isFullyAvailable) {
      return { message: t('Available'), className: '' };
    }

    // Check for partial availability (any overlap)
    const isPartiallyAvailable = room.availability.some(([start, end]) => {
      return timeToMinutes(start) < eventEndMinutes && timeToMinutes(end) > eventStartMinutes;
    });

    if (isPartiallyAvailable) {
      return { message: t('Available some hours'), className: PARTIALLY_AVAILABLE };
    }

    return status;
  }, [room.availability, startTime, endTime, t]);

   const getCurrentColor = (className) => {
    if (className === NOT_AVAILABLE) return "severe";
    if (className === PARTIALLY_AVAILABLE) return "warning";
    return "success";
  };

  const status = determineStatus();

  // Notify parent of the current status after render.
  // Using useEffect prevents calling setStatus during render,
  // which would trigger an infinite re-render loop.
  useEffect(() => {
    setStatus(determineStatus());
  }, [determineStatus]);

  return (
    <Stack direction="row" gap="8px" alignItems={"center"}>
      <Badge size="extra-small" color={getCurrentColor(status.className)} />
      <Text size={200}>{status.message}</Text>
    </Stack>
  )
}

export default Status;